import api from "../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  activeOffersList() {
    return api.get(`client/offers/list`);
  },
};
